import { render, staticRenderFns } from "./ListReleases.vue?vue&type=template&id=8eb57884"
import script from "./ListReleases.vue?vue&type=script&lang=js"
export * from "./ListReleases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports